import type { FaireProductEntity } from "../../entity_types/product";

export const p_mykeqwk595: FaireProductEntity = {
  token: "p_mykeqwk595",
  type: "product",
  name: "Set of 6 Walnut Handled Cheese Knives",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/c8427f06e2cd8daf15324af37a6b208e1a2f6c6dcefd42b89b619f46b74979a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12a3475ec13aa121d084382f8a4c6d0e035ef98d06e847454ec23488b2125184.jpeg",
    "https://cdn.faire.com/fastly/0d6e5dc6e8b62e2be68d7d9d63158910cd31ebedca1cd49631f0889c8f84c896.jpeg",
    "https://cdn.faire.com/fastly/d2bb66d4d629b36067a202d3bfa13bce9eaab7f3fdfe8fda2c4f848b57f8601c.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Our Set of 6 Walnut Handled Cheese Knives come beautifully boxed to elevate the gift giving experience. Stainless steel blades are coated with a sleek black Teflon finish. Perfect for charcuterie and cheese boards.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:14.575Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
